export const UnVerifiedStudentsType = {
    FETCH_UNVERIFIED_STUDENT_START: 'FETCH_UNVERIFIED_STUDENT_START',
    FETCH_UNVERIFIED_STUDENT_SUCCESS: 'FETCH_UNVERIFIED_STUDENT_SUCCESS',
    FETCH_UNVERIFIED_STUDENT_FAILURE: 'FETCH_UNVERIFIED_STUDENT_FAILURE',
    APPROVE_STUDENT_START: 'APPROVE_STUDENT_START',
    APPROVE_STUDENT_SUCCESS: 'APPROVE_STUDENT_SUCCESS',
    APPROVE_STUDENT_FAILURE: 'APPROVE_STUDENT_FAILURE'
}